import { render, staticRenderFns } from "./OptionsCorrectOrder.vue?vue&type=template&id=621e4ab8&scoped=true&"
import script from "./OptionsCorrectOrder.vue?vue&type=script&lang=js&"
export * from "./OptionsCorrectOrder.vue?vue&type=script&lang=js&"
import style0 from "./OptionsCorrectOrder.vue?vue&type=style&index=0&id=621e4ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621e4ab8",
  null
  
)

export default component.exports